export const adsApiEndpoints = {
  getAds: (eventType: string, page: number, limit: number) =>
    `/events?event=${eventType}&page=${page}&limit=${limit}`,
  getAdById: (id: string, event: string) => `/events/${id}?event=${event}`,
  updateItemDetails: (id: string, event: string) =>
    `/events/${id}?event=${event}`,
  deleteItemDetails: (id: string, event: string) =>
    `/events/${id}?event=${event}`,
  createAd: `/ads`,
  updateAd: (id: string) => `/ads/${id}`,
  deleteAd: (id: string) => `/ads/${id}`,
};
